/**
 * Wire-contract values for the `logType` / "Message Type" filter on the admin Logs screen.
 * Sent verbatim to the server-side `logType` filter and expected to match the stored casing
 * exactly, so they live here as a closed vocabulary rather than as inline component literals.
 */
export enum CatchHubLogType {
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
}

/** Dropdown options for the Message Type filter. */
export const CATCH_HUB_LOG_TYPE_OPTIONS: ReadonlyArray<{ label: string; value: CatchHubLogType }> = [
  { label: 'Info', value: CatchHubLogType.Info },
  { label: 'Warning', value: CatchHubLogType.Warning },
  { label: 'Error', value: CatchHubLogType.Error },
];

/**
 * `eventType` values this app writes. The admin Logs screen builds its Event Type filter from the
 * distinct values already stored, so a row written with a value that is not listed here is still
 * filterable - these exist so the strings are declared once rather than inlined at each call site.
 */
export enum CatchHubEventType {
  IntelliCatch = 'IntelliCatch',
  CopilotSignIn = 'CopilotSignIn',
  CopilotLimit = 'CopilotLimit',
  ConfigurationError = 'ConfigurationError',
}
